import { useQueryClient } from '@tanstack/react-query';

import { gql } from '@/utilities/gql';
import { makeGqlMutation } from '@/utilities/gqlQuery';

import { PORTFOLIO_QUERY_KEY } from '@/hooks/portfolio/usePortfolio';
import { AGGREGATE_PORTFOLIO_QUERY_KEY } from '@/hooks/portfolio/useAggregatePortfolio';
import { usePortfolioTransactions } from './usePortfolioTransactions';

import type { ResultOf, VariablesOf } from '@/utilities/gql';

const MUTATION = gql(`
  mutation updateTransactionPortfolio($id: String!, $transactions: [ManualTransactionInput!]!) {
    updateTransactionPortfolio(id: $id, transactions: $transactions) {
      id
    }
  }
`);

export type TransactionInput = VariablesOf<
  typeof MUTATION
>['transactions'][number];

const mutation = makeGqlMutation(MUTATION);

interface Props {
  onSuccess?: (data: ResultOf<typeof MUTATION>) => void;
}

export const useUpdateTransactionPortfolio = ({ onSuccess }: Props = {}) => {
  const queryClient = useQueryClient();
  return mutation({
    onSuccess: (data, { id: portfolioId }) => {
      queryClient.invalidateQueries(
        usePortfolioTransactions.getOptions({
          id: portfolioId,
        })
      );
      queryClient.invalidateQueries({
        queryKey: [PORTFOLIO_QUERY_KEY, portfolioId],
      });
      queryClient.invalidateQueries({
        queryKey: AGGREGATE_PORTFOLIO_QUERY_KEY,
      });
      onSuccess?.(data);
    },
  });
};
